module.exports = __webpack_public_path__ + "img/element-heading.41690a3.svg";